import { NotifyHelper } from "../../../helpers/toast";
import { ePhanPhongHocActionsObj } from "../../action-types/tkb/IPhanPhongActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const phanPhongHocActions = {
  ...generateActions(ePhanPhongHocActionsObj, "PHAN_PHONG_HOC"),
  ...generateActionForKey(ePhanPhongHocActionsObj, "PHAN_PHONG_HOC", "UPDATE_GV_PH_SUKIEN_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
  ...generateActionForKey(ePhanPhongHocActionsObj, "PHAN_PHONG_HOC", "UPDATE_GV_PH_SUKIEN_ERRR", (m) => { NotifyHelper.Error(m) }),

};
